// extracted by mini-css-extract-plugin
export default {"root":"CellActions_root__6ISh4","icon":"CellActions_icon__nrDoM","placeHolderShimmer":"CellActions_placeHolderShimmer__pxaht"};